var map = {
	"./basic/assets/languages/en.json": 4478,
	"./cmbi/assets/languages/en.json": 58073,
	"./eif/assets/languages/en.json": 41316,
	"./fubon/assets/languages/en.json": 47652,
	"./scb/assets/languages/en.json": 55972,
	"./ttl/assets/languages/en.json": 93776
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48135;